import { Module } from "vuex";
import { RootState } from "@/store/types";
import { GlobalSearchState } from "./types";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";

const state: GlobalSearchState = {
  zipCodeSearchCheck: false,
};

export const globalSearch: Module<GlobalSearchState, RootState> = {
  state,
  getters,
  mutations,
};
